import { TabPane, Tab } from 'semantic-ui-react';
import { DiscipleshipRange } from './Discipulado/DiscipleshipRange';
import { useEffect } from 'react';
import { useState } from 'react';
import groupService from 'src/services/api/groupService';
import { DashboardGroupsComponent } from './styles/DashboardGroupsComponent';
import moment from 'moment';

export const getTotalsGraph = (data, valVar = 'value') =>
  data?.reduce?.((acc, item) => acc + item?.[valVar], 0);

const defaultFromRange = moment().startOf('year').format('YYYY-MM-DD');
const defaultToRange = moment().format('YYYY-MM-DD');

const DiscipleshipCharts = () => {
  const [closedGroupsNotGrouped, setClosedGroupNotGrouped] = useState([]);
  const [openGroupsNotGrouped, setOpenGroupsNotGrouped] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromRange, setFromRange] = useState(defaultFromRange);
  const [toRange, setToRange] = useState(defaultToRange);
  const [toCut, setToCut] = useState(defaultToRange);

  useEffect(() => {
    bringInfoNoFiltered();
  }, []);

  const bringInfoNoFiltered = async () => {
    const responseClosed = await groupService.getClosedGroups({
      noFilter: true,
    });
    const groupsClosed = responseClosed.data.groups;
    setClosedGroupNotGrouped(groupsClosed);
    const responseOpen = await groupService.getAllGroupsByLeader({
      noFilter: true,
      excludeSuspended: true,
    });
    const openGroups = responseOpen.data.groups;
    setOpenGroupsNotGrouped(openGroups);
    setLoading(false);
  };

  const panes = [
    {
      menuItem: 'Consultas a Corte',
      render: () => (
        <Tab.Pane>
          <DiscipleshipRange
            openGroupsNotGrouped={openGroupsNotGrouped}
            closedGroupsNotGrouped={closedGroupsNotGrouped}
            kindOfBoard="cut"
            toCut={toCut}
            setToCut={setToCut}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Consultas por Rango',
      render: () => (
        <TabPane>
          <DiscipleshipRange
            openGroupsNotGrouped={openGroupsNotGrouped}
            closedGroupsNotGrouped={closedGroupsNotGrouped}
            kindOfBoard="range"
            fromRange={fromRange}
            toRange={toRange}
            setFromRange={setFromRange}
            setToRange={setToRange}
          />
        </TabPane>
      ),
    },
  ];
  return (
    <DashboardGroupsComponent>
      <h2 className="h2Title">Discipulado</h2>
      {loading && (
        <div className="containerSpinner">
          <div className="spinner"></div>
          <div className="loadingText">Cargando Información de Grupos.</div>
        </div>
      )}
      {!loading && (
        <div className="dashboard-body">
          <Tab panes={panes} />
        </div>
      )}
    </DashboardGroupsComponent>
  );
};

export default DiscipleshipCharts;
